/* eslint-disable no-case-declarations */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/alert';
import Coordinate from 'services/utils/Coordinate';
import { measureArea, measureLength } from 'services/utils/measures';

import featureStyles from 'views/MapView/services/symbologiesStyles.json';

/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

/**
 * Função para criar o GeoJson da geometria
 * @param {Array} coords Array de coordenadas
 * @param {'Point'|'Line'|'Polygon'} type Tipo da geometria
 * @param {*} data Dados da geometria. Para os pontos os dados devem estar no array de coordenadas
 */
const makeFeature = (coords, type, data) => {
  let features = null;
  if (coords && coords.length) {
    const customRender = L.canvas();
    let style = featureStyles.filter((s) => s.for === type)[0];
    let options = {
      renderer: customRender,
      style,
      pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng, {
          ...style,
          renderer: customRender,
        });
      },
    };
    switch (type) {
      case 'Point':
        {
          let points = [];
          coords.forEach((c) => {
            let newPoint = turf.point(
              [c.lng, c.lat],
              c.data ? { ...c.data } : undefined
            );
            points.push(L.geoJSON(newPoint, options));
          });
          features = points;
        }
        break;
      case 'Line':
        {
          let line = null;
          if (coords.length > 1) {
            line = turf.lineString(
              coords.map((c) => [c.lng, c.lat]),
              data ? { ...data } : undefined
            );
            features = L.geoJSON(line, options).getLayers();
          } else {
            geoAlert({
              message: 'Adicione outro(s) ponto(s) para transformar em linha',
            });
          }
        }
        break;
      case 'Polygon':
        {
          let polygon = null;
          if (coords.length > 2) {
            let polygonCoords = coords.map((c) => [c.lng, c.lat]);
            polygonCoords.push(polygonCoords[0]);
            polygon = turf.polygon(
              [polygonCoords],
              data ? { ...data } : undefined
            );
            features = L.geoJSON(polygon, options).getLayers();
          } else {
            geoAlert({
              message:
                'Adicione outro(s) ponto(s) para transformar em polígono',
            });
          }
        }
        break;
      default:
        features = null;
    }
  }
  return features;
};

// ! Coloquei essa função aqui para não repetir código e a mensagem grande enquanto também não se define a mensagem em documentação, ficando mais fácil de alterar.
const invalidTopologyAlert = () => {
  geoAlert({
    message:
      'Geometria inválida. O cruzamento de linhas na geometria não é permitido. Reordene ou exclua os pontos relacionados a esse evento para tornar a geometria válida.',
  });
};
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const reorderedItemsOnDragEnd = (result, items) => {
  // dropped outside the list
  if (!result.destination) {
    return items;
  }

  return reorder(
    items,
    result.source.index,
    result.destination.index
  );  
};

const defaultFeaturePmOptions = {
  allowSelfIntersection: false,
  snappable: false,
  preventMarkerRemoval: true,
  hideMiddleMarkers: true,
};

export const initialToolState = {
  coordsList: [],
  coordsListRaw: [],
  features: [],
  displayModal: false,
  modalRelativePosition: { x: -200, y: -200 },
  modalState: 'add',
  featureType: 'Point',
  displaySaveModal: false,
  layerNameToSave: '',
  layerStyleToSave: null,
  saveLayerNameError: '',
  coordsChanged: false,
};

const polylineOptions = {
  vertexDistances: {
    enable: true,
    position: 'centered',
    tooltip: true,
  },
  showMarkerPoints: true,
};

const polygonOptions = {
  vertexDistances: {
    enable: false,
    tooltip: true,
  },
  showTempPolygon: true,
  showMarkerPoints: true,
};

export default (state, action) => {
  const removeAllFeatures = () => {
    state.features.forEach((feature) => {
      feature.remove();
    });
  };

  const isSelfIntersecting = (listOfCoords, featureType) => {
    if (featureType === 'Line' || state.featureType === 'Line') {
      if (listOfCoords.length > 1) {
        let polyline = turf.lineString(
          listOfCoords.map((c) => [parseFloat(c.lng), parseFloat(c.lat)])
        );
        return turf.kinks(polyline).features.length > 0;
      }
    } else if (featureType === 'Polygon' || state.featureType === 'Polygon') {
      if (listOfCoords.length > 2) {
        let polygonCoords = listOfCoords.map((c) => [
          parseFloat(c.lng),
          parseFloat(c.lat),
        ]);
        polygonCoords.push(polygonCoords[0]);
        let polygon = turf.polygon([polygonCoords]);
        return turf.kinks(polygon).features.length > 0;
      }
    } else {
      return false;
    }
  };



  function validateCoordinates(lat, lng) {
    lat = parseFloat(lat);
    lng = parseFloat(lng);

  
    const format = detectFormatCoordinates(lat, lng);

    return format !== 'Indefinido';
  }
  
  function detectFormatCoordinates(lat, lng) {
    if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
      return 'Graus Decimais';
    }
  
    if (lat >= 0 && lat <= 10000000 && lng >= 0 && lng <= 10000000) {
      return 'UTM';
    }
  
    return 'Indefinido';
  }
  


  const closeModal = (state) => {
    return { ...state, displayModal: false };
  };
  
  const openModal = (state) => {
    return { ...state, displayModal: true };
  };

  const setModalState = (state, action) => {
    const validStates = ['add', 'reorder'];
    if (!validStates.includes(action.payload)) {
      throw new Error('estado de modal inválido');
    }
    return { ...state, modalState: action.payload };
  };


  switch (action.type) {
    case 'closeModal':
      return closeModal(state);
    case 'openModal':
      return openModal(state);
    case 'setModalState':
     return setModalState(state, action);
     
    case 'addPoints': {
      // Os pontos que vem da ferramenta vem em RAW temos aqui que transformar a medida, dependendo do tipo
      const { map, type, csv: isCsv, reset: reseting, listOfCoords } = action.payload;
      if (listOfCoords.length === 0) {
        geoAlert({
          message: 'A lista de coordenadas está vazia.',
        })
        return state;
      }

      const transformCoords = (cur) => {
        const { lat, lng, zone, projection, data } = cur;

        if (!validateCoordinates(lat, lng)) {
          geoAlert({
            message: 'As coordenadas devem ser números válidos.',
          });
                    return false;
        }

        const coords = new Coordinate([lng, lat], zone, type.value, projection);
        const [lngDD, latDD] = coords.getDD('WGS84');

        return { lng: lngDD, lat: latDD, data, csv: isCsv };
      };
      
      const coordsList = reseting
        ? state.coordsList.filter((v) => !v.csv).concat(listOfCoords.map(transformCoords).filter(Boolean))
        : state.coordsList.concat(listOfCoords.map(transformCoords).filter(Boolean));

      if (coordsList.length === 0) {
        console.error('A lista de coordenadas deve conter pelo menos uma coordenada válida.');
        return state;
      }


      const coordsListRaw = reseting
        ? state.coordsListRaw.filter((v) => !v.csv).concat(
            listOfCoords.map(({ lat, lng, zone, projection, data }) =>{
              return ({
                lat: lat?.replace(',', '.') ?? '',
                lng: lng?.replace(',', '.') ?? '',
                zone,
                projection,
                data,
                csv: isCsv,
              })
            })
          )
        : state.coordsListRaw.concat(
            listOfCoords.map(({ lat, lng, zone, projection, data }) => ({
              lat: lat?.replace(',', '.') ?? '',
              lng: lng?.replace(',', '.') ?? '',
              zone,
              projection,
              data,
              csv: isCsv,
            }))
          );

      // Create features
      const features = makeFeature(coordsList, state.featureType);
      if (state.featureType !== 'Point' && isSelfIntersecting(coordsList)) {
        invalidTopologyAlert();
        return state;
      }

      // Add features to map
      removeAllFeatures();
      features.forEach((f) => f.addTo(map));
      if (state.featureType !== 'Point') {
        features[0].pm.enable(defaultFeaturePmOptions);
        features[0].showMeasurements(
          state.featureType === 'Polygon' ? polygonOptions : polylineOptions
        );
        action.payload.listenToUpdates?.({ layer: features[0] });
      }

      // Update state
      return {
        ...state,
        coordsList,
        coordsListRaw,
        features,
        coordsChanged: reseting ? false : state.coordsChanged,
      };

    }

  
    case 'setLng': {
      let isCsv = state.coordsListRaw[action.payload.index].csv;
      let coord = new Coordinate(
        [action.payload.lng, state.coordsListRaw[action.payload.index].lat],
        state.coordsListRaw[action.payload.index].zone,
        action.payload.type.value,
        action.payload.type.projection || 'WGS84'
      );
      let lngCoordinate = coord.getDD('WGS84')[0];

      if (lngCoordinate.replace(/\D/gi, '').length > 0) {
        state.coordsList[action.payload.index] = {
          ...state.coordsList[action.payload.index],
          lng: lngCoordinate,
        };
        state.coordsListRaw[action.payload.index] = {
          ...state.coordsListRaw[action.payload.index],
          lng: action.payload.lng,
        };
      } else {
        return state;
      }

      if (action.payload.update) {
        let feature = state.features;
        const map = action.payload.map;

        if (
          state.featureType !== 'Point' &&
          isSelfIntersecting(state.coordsList)
        ) {
          invalidTopologyAlert();
          return state;
        }
        feature = makeFeature(state.coordsList, state.featureType);
        removeAllFeatures();
        feature.length && feature.forEach((f) => f.addTo(map));
        if (state.featureType !== 'Point') {
          feature[0].pm.enable(defaultFeaturePmOptions);
          feature[0].showMeasurements(
            state.featureType === 'Polygon' ? polygonOptions : polylineOptions
          );
          action.payload.listenToUpdates({ layer: feature[0] });
        }
        return {
          ...state,
          features: [...feature],
          coordsChanged: isCsv ? true : state.coordsChanged,
        };
      } else {
        return state;
      }
    }
    case 'setLat': {
      let isCsv = state.coordsListRaw[action.payload.index].csv;
      let coord = new Coordinate(
        [state.coordsListRaw[action.payload.index].lng, action.payload.lat],
        state.coordsListRaw[action.payload.index].zone,
        action.payload.type.value,
        action.payload.type.projection || 'WGS84'
      );
      let latCoordinate = coord.getDD('WGS84')[1];

      if (latCoordinate.replace(/\D/gi, '').length > 0) {
        state.coordsList[action.payload.index] = {
          ...state.coordsList[action.payload.index],
          lat: latCoordinate,
        };
        state.coordsListRaw[action.payload.index] = {
          ...state.coordsListRaw[action.payload.index],
          lat: action.payload.lat,
        };
      } else {
        return state;
      }

      if (action.payload.update) {
        let feature = state.features;
        const map = action.payload.map;

        if (
          state.featureType !== 'Point' &&
          isSelfIntersecting(state.coordsList)
        ) {
          invalidTopologyAlert();
          return state;
        }
        feature = makeFeature(state.coordsList, state.featureType);
        removeAllFeatures();
        feature.length && feature.forEach((f) => f.addTo(map));
        if (state.featureType !== 'Point') {
          feature[0].pm.enable(defaultFeaturePmOptions);
          feature[0].showMeasurements(
            state.featureType === 'Polygon' ? polygonOptions : polylineOptions
          );
          action.payload.listenToUpdates({ layer: feature[0] });
        }
        return {
          ...state,
          features: [...feature],
          coordsChanged: isCsv ? true : state.coordsChanged,
        };
      } else {
        return state;
      }
    }
    case 'setCoords': {
      let isCsv = false;
      // Ao setar as coordenadas eles recebem em DD, deve ser então convertido para o tipo de coordenadas que está selecionado, para ser exibido
      let coordsListRaw = state.coordsListRaw;
      action.payload.coordsList.forEach((coords, index) => {
        if (
          coords.lat !== state.coordsList[index].lat ||
          coords.lng !== state.coordsList[index].lng
        ) {
          isCsv = coords.csv ? true : isCsv;
          let coordinates = new Coordinate(
            [coords.lng, coords.lat],
            null,
            'DD'
          );
          switch (action.payload.type.value) {
            case 'DMS':
              {
                let [lng, lat] = coordinates.getDMS(
                  action.payload.type.projection || 'WGS84'
                );
                coordsListRaw[index] = {
                  ...coordsListRaw[index],
                  lat,
                  lng,
                };
              }
              break;
            case 'UTM':
              {
                let utmCords = coordinates.getUTM(
                  action.payload.type.projection || 'WGS84'
                );
                coordsListRaw[index] = {
                  lat: utmCords.coords[1],
                  lng: utmCords.coords[0],
                  zone: utmCords.zone,
                };
              }
              break;
            default: {
              let [lng, lat] = coordinates.getDD(
                action.payload.type.projection || 'WGS84'
              );
              coordsListRaw[index] = {
                ...coordsListRaw[index],
                lat,
                lng,
              };
            }
          }
        }
      });

      return {
        ...state,
        coordsList: [...action.payload.coordsList],
        coordsListRaw,
        coordsChanged: isCsv ? true : state.coordsChanged,
      };
    }
    case 'removeCoords': {
      let isCsv = state.coordsList[action.payload.index].csv;
      // verifica o número de pontos, se forem 3 no final deve transformar em pontos nomavemnte
      const coordsList = state.coordsList.filter(
        (_, index) => index !== action.payload.index
      );
      const coordsListRaw = state.coordsListRaw.filter(
        (_, index) => index !== action.payload.index
      );
      let feature = state.features;
      let featureType;
      if (state.featureType !== 'Point') {
        const map = action.payload.map;
        if (coordsList.length <= 1) {
          // transforma tudo em pontos novamente
          feature = [];
          featureType = 'Point';
          removeAllFeatures();
          feature = makeFeature(coordsList, featureType);
          feature.length && feature.forEach((f) => f.addTo(map));
        } else {
          if (state.featureType === 'Polygon') {
            if (coordsList.length >= 3) {
              featureType = 'Polygon';
              feature = makeFeature(coordsList, featureType);
              feature.length && feature.forEach((f) => f.addTo(map));
            } else {
              featureType = 'Line';
              feature = makeFeature(coordsList, featureType);
              feature.length && feature.forEach((f) => f.addTo(map));
            }
          } else if (state.featureType === 'Line') {
            if (coordsList.length >= 2) {
              featureType = 'Line';
              feature = makeFeature(coordsList, featureType);
              feature.length && feature.forEach((f) => f.addTo(map));
            } else {
              featureType = 'Point';
            }
          }
          removeAllFeatures();
          feature[0].pm.enable(defaultFeaturePmOptions);
          feature[0].showMeasurements(
            state.featureType === 'Polygon' ? polygonOptions : polylineOptions
          );
          action.payload.listenToUpdates({ layer: feature[0] });
        }
      } else {
        featureType = 'Point';
        state.features[action.payload.index].remove();
        feature = state.features.filter(
          (_, index) => index !== action.payload.index
        );
      }
      return {
        ...state,
        features: [...feature],
        featureType,
        coordsList,
        coordsListRaw,
        coordsChanged: isCsv ? true : state.coordsChanged,
      };
    }
    case 'reorderCoords': {
      // Atualiza desenho
      let feature = state.features,
        selfIntersected = false;

      switch (state.featureType) {
        case 'Polygon': {
          selfIntersected = isSelfIntersecting(state.coordsList, 'Polygon');
          break;
        }
        case 'Line': {
          selfIntersected = isSelfIntersecting(state.coordsList, 'Polygon');
          break;
        }
        default: {
          selfIntersected = false;
        }
      }
      if (!selfIntersected) {
        let sourceIndex = action.payload.result.source.index,
          destinationIndex = action.payload.result.destination.index;
        let isCsv =
          state.coordsList[sourceIndex].csv ||
          state.coordsList[destinationIndex].csv;
        const coordsList = reorderedItemsOnDragEnd(
            action.payload.result,
            state.coordsList
          ),
          coordsListRaw = reorderedItemsOnDragEnd(
            action.payload.result,
            state.coordsListRaw
          );
        if (state.featureType !== 'Point') {
          const map = action.payload.map;
          if (state.featureType === 'Polygon') {
            feature = makeFeature(coordsList, state.featureType);
            feature.length && feature.forEach((f) => f.addTo(map));
          } else if (state.featureType === 'Line') {
            feature = makeFeature(coordsList, state.featureType);
            feature.length && feature.forEach((f) => f.addTo(map));
          }
          removeAllFeatures();
          feature[0].pm.enable(defaultFeaturePmOptions);
          feature[0].showMeasurements(
            state.featureType === 'Polygon' ? polygonOptions : polylineOptions
          );
          action.payload.listenToUpdates({ layer: feature[0] });
        }
        return {
          ...state,
          features: [...feature],
          coordsList,
          coordsListRaw,
          coordsChanged: isCsv ? true : state.coordsChanged,
        };
      } else {
        return state;
      }
    }
    case 'transformToLines': {
      if (state.coordsList.length > 1) {
        if (!isSelfIntersecting(state.coordsList, 'Line')) {
          const map = action.payload.map;
          const polyline = makeFeature(state.coordsList, 'Line')[0];
          removeAllFeatures();
          polyline.pm.enable(defaultFeaturePmOptions);
          polyline.showMeasurements(polylineOptions);
          action.payload.listenToUpdates({ layer: polyline });
          polyline.addTo(map);
          return {
            ...state,
            features: [polyline],
            featureType: 'Line',
          };
        } else {
          invalidTopologyAlert();
          return state;
        }
      } else {
        geoAlert({ message: 'Adicione outro ponto para transformar em linha' });
        return state;
      }
    }
    case 'transformToPolygon': {
      if (state.coordsList.length > 2) {
        if (!isSelfIntersecting(state.coordsList, 'Polygon')) {
          const map = action.payload.map;
          const polygon = makeFeature(state.coordsList, 'Polygon')[0];
          removeAllFeatures();
          polygon.pm.enable(defaultFeaturePmOptions);
          polygon.showMeasurements(polygonOptions);
          action.payload.listenToUpdates({ layer: polygon });
          polygon.addTo(map);
          return {
            ...state,
            features: [polygon],
            featureType: 'Polygon',
          };
        } else {
          invalidTopologyAlert();
          return state;
        }
      } else {
        geoAlert({
          message: 'Adicione outro(s) ponto(s) para transformar em polígono',
        });
        return state;
      }
    }
    case 'transformToPoints': {
      const map = action.payload.map;
      let feature = [];
      feature = makeFeature(state.coordsList, 'Point');
      feature.length && feature.forEach((f) => f.addTo(map));
      removeAllFeatures();
      return {
        ...state,
        features: [...feature],
        featureType: 'Point',
      };
    }
    case 'deleteAllFeatures': {
      if (action.payload?.silent) {
        state.features.forEach((feature) => feature.remove());
        state.features.coordsChanged = false
        state.features.coordsList = []
        state.features.coordsListRaw = []
        state.features.displayModal = false
        state.features.displaySaveModal = false
        state.featureType = "Point"
        state.features = []
        state.features.layerNameToSave = ""
        state.features.layerStyleToSave = null
        state.features.modalRelativePosition = {x: -200, y: -200}
        state.features.modalState = "add"
        state.features.saveLayerNameError = ""
        return {
          ...initialToolState,
          displayModal: state.displayModal,
          modalRelativePosition: state.modalRelativePosition,
          modalState: state.modalState,
          featureType: state.featureType,
        };
      } else {
        return state;
      }
    }
    case 'flyTo': {
      const lat =
          typeof action.payload.lat === 'number'
            ? action.payload.lat
            : parseFloat(action.payload.lat.replace(',', '.')),
        lng =
          typeof action.payload.lng === 'number'
            ? action.payload.lng
            : parseFloat(action.payload.lng.replace(',', '.'));
      action.payload.map.flyTo(L.latLng({ lat, lng }), 13);
      // TODO em vez de colocar números aleatórios o certo aqui é calcular se o modal está tapando pelos "bounds" se não tiver deixa onde está, se tiver movimenta, mas exige muito esforço. Só quando tiver menos demanda.
      return { ...state, modalRelativePosition: { x: 180, y: -150 } };
    }
    case 'resetModalRelativePosition':
      return { ...state, modalRelativePosition: { x: -200, y: -200 } };
    case 'openSaveModal':
      return { ...state, displaySaveModal: true };
    case 'closeSaveModal':
      return { ...state, displaySaveModal: false };
    case 'setLayerNameToSave': {
      const layerNameToSave = action.payload;
      let saveLayerNameError;
      if (layerNameToSave === '') {
        saveLayerNameError = 'Campo obrigatório.';
      } else if (layerNameToSave.length >= 70) {
        saveLayerNameError =
          'Nome da camada não deve ter mais que 70 caracteres.';
      }
      return { ...state, layerNameToSave, saveLayerNameError };
    }
    case 'setLayerStyleToSave':
      return { ...state, layerStyleToSave: action.payload };
    case 'saveAsLayer': {
      if (
        state.layerNameToSave !== '' &&
        state.layerNameToSave.trim() !== '' &&
        state.saveLayerNameError !== '' &&
        state.features.length > 0
      ) {
        removeAllFeatures();
        const newLayer = L.featureGroup(state.features).toGeoJSON(14);
        const customRender = L.canvas({ pane: 'mixedPane' });
        const geoJsonLayer = L.geoJSON(newLayer, {
          pane: 'mixedPane',
          renderer: customRender,
          style: state.layerStyleToSave,
          pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, {
              ...state.layerStyleToSave,
              renderer: customRender,
            });
          },
        });
        let layerToAdd = new Layer(
          null,
          'criada',
          null,
          state.layerNameToSave,
          null,
          null,
          null,
          null,
          null
        );
        layerToAdd.setLeafletLayer(geoJsonLayer);
        layerToAdd.setLayerStyle(state.layerStyleToSave);

        let countIdFeature = 1;      
        layerToAdd.leafletLayer.eachLayer((feature) => {          
          feature.feature.properties.ID_GBA = countIdFeature;          
          countIdFeature++;
          if (!['Point', 'MultiPoint'].includes(feature.feature.geometry.type)) {
            if (["Line", "LineString", "MultiLineString"].includes(feature.feature.geometry.type)) {
              feature.feature.properties['Comprimento (m)'] = measureLength(feature.feature.geometry.coordinates, true);
            } else {
              feature.feature.properties['Área (m²)'] = measureArea(feature.feature.geometry.coordinates, true);
              feature.feature.properties['Área (ha)'] = measureArea(feature.feature.geometry.coordinates, true) / 10000;
            }
          }else{
            feature.feature.properties = {
              ...feature.feature.properties,
              "Latitude": feature.feature.geometry.coordinates[1],
              "Longitude": feature.feature.geometry.coordinates[0]
            }
          }        
        });

        action.payload.mapContext.addLayer(layerToAdd);
        action.payload.callback({
          ...state,
          features: [],
          coordsList: [],
          layerNameToSave: '',
          displaySaveModal: false,
        });
        return {
          ...state,
          features: [],
          coordsList: [],
          layerNameToSave: '',
          displaySaveModal: false,
          featureType: initialToolState.featureType,
        };
      } else {
        // O campo de nome pode nunca ter sido tocado, exibir campo obrigatório nesse caso também
        let saveLayerNameError = state.saveLayerNameError;
        if (
          state.layerNameToSave.trim() === '' ||
          state.saveLayerNameError === ''
        ) {
          saveLayerNameError = 'Campo obrigatório!';
        }
        action.payload.callback({
          error: saveLayerNameError,
        });
        return { ...state, saveLayerNameError };
      }
    }
    case 'resetState':
      return { ...initialToolState, featureType: state.featureType };
    default:
      throw new Error();
  }
};